var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _circle, _circle2, _rect13, _rect14, _rect15, _rect16, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 88,
    viewBox: "0 0 150 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 87,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 87,
    rx: 5.5,
    stroke: "#030F23"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1562,
    y: 17.918,
    width: 116.612,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1562,
    y: 23.7275,
    width: 99.6766,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1562,
    y: 29.5381,
    width: 116.612,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1562,
    y: 35.3477,
    width: 36.9972,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 55.9648,
    y: 35.3477,
    width: 36.9972,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7695,
    y: 35.3477,
    width: 36.9972,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1562,
    y: 48.125,
    width: 116.612,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1562,
    y: 53.9346,
    width: 114.504,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1562,
    y: 59.7451,
    width: 76.5703,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1562,
    y: 65.5547,
    width: 116.612,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1562,
    y: 71.3643,
    width: 99.6766,
    height: 3,
    rx: 1.5,
    fill: "#E6E7E9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4414,
    y: 13.5,
    width: 124.744,
    height: 28.5041,
    stroke: "#12ABBF",
    strokeDasharray: "1.4 1.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9297,
    cy: 12.9883,
    r: 3.5,
    fill: "#12ABBF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.672,
    cy: 42.4922,
    r: 3.5,
    fill: "#12ABBF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 46,
    width: 52,
    height: 31,
    rx: 2,
    fill: "#030F23"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 49,
    width: 41,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 54,
    width: 32,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 59,
    width: 42,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 70,
    r: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116 72V68M116 68L115 69M116 68L117 69",
    stroke: "#030F23",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftItem);
export default __webpack_public_path__ + "static/media/left-item.ce1a9d7a401d5f5f39d228281807808c.svg";
export { ForwardRef as ReactComponent };